export interface BatteryRange {
  id: string;
  documentId?: string;
  code: string;
  name?: string;
  description?: string;
  minCellVoltage?: number;
  blockVoltages?: number[];
}

export function batteryRangesCodes(ranges: BatteryRange[]): string[] {
  return ranges
    .map((range) => range.code?.trim())
    .filter((code): code is string => !!code?.length);
}

export function formatBatteryRanges(
  ranges?: BatteryRange[] | null,
  separator = ', ',
): string {
  if (!ranges?.length) {
    return '';
  }
  return batteryRangesCodes(ranges).join(separator);
}
